import { useCallback, useEffect, useState } from 'react';
import { getAgents, addAgent, removeAgent } from 'api';

// Loads and manages the Claude agents added to a single channel (a channel's
// agent membership, independent of who is currently online). Re-fetches
// whenever the channel changes.
export const useAgents = (channelId) => {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!channelId) {
      setAgents([]);
      setLoading(false);
      setError(null);
      return undefined;
    }

    let active = true;
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getAgents(channelId);
        if (active) setAgents(data);
      } catch (e) {
        if (active) setError(e.message);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [channelId]);

  const createAgent = useCallback(async () => {
    const agent = await addAgent(channelId);
    setAgents((prev) => [...prev, agent]);
    return agent;
  }, [channelId]);

  const deleteAgent = useCallback(async (agentId) => {
    await removeAgent(channelId, agentId);
    setAgents((prev) => prev.filter((agent) => agent.id !== agentId));
  }, [channelId]);

  return { agents, loading, error, createAgent, deleteAgent };
};
